export default "__VITE_ASSET__D1j3nenV__"